"use client"
import { useEffect, useRef } from "react"
import Title from "../Title/Title"
import Card from "../Card/Card"
import "aos/dist/aos.css"

function Whysection() {
  const sectionRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    // Lazy-load heavy background image only when section enters viewport
    const el = sectionRef.current
    if (!el) return
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.style.backgroundImage = "url('/bg-why.jpg')"
          observer.disconnect()
        }
      },
      { rootMargin: "200px" },
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  // Card data array for dynamic rendering
  const cards = [
    {
      title: "Local Expertise",
      description:
        "Arabic-speaking analysts with top certifications (GIAC, OSCP, CISSP).",
      className:
        "bg-[--color-brand] text-[--color-dark] min-h-[300px] xl:min-h-[500px]",
      titleClassName: "text-[24px] xl:text-[48px] text-white uppercase",
      descClassName: "text-white ",
      aosDelay: "200",
    },
    {
      title: "Riyadh Data Center",
      description: "Ensures data sovereignty and high performance.",
      className: "bg-white text-[--color-gray] min-h-[300px] xl:min-h-[500px]",
      titleClassName:
        "text-[24px] xl:text-[48px] text-[--color-dark] uppercase",
      descClassName: "",
      aosDelay: "400",
    },
    {
      title: "24/7 Threat Monitoring",
      description:
        "Real-time detection, incident response, and vulnerability management.",
      className: "bg-white text-[--color-gray] min-h-[300px] xl:min-h-[500px]",
      titleClassName:
        "text-[24px] xl:text-[48px] text-[--color-dark] uppercase",
      descClassName: "",
      aosDelay: "600",
    },
    {
      title: "Built for Compliance",
      description: "Aligns with SAMA, NCA-ECC, PCI DSS, and more.",
      className: "bg-white text-[--color-gray] min-h-[300px] xl:min-h-[500px]",
      titleClassName:
        "text-[24px] xl:text-[48px] text-[--color-dark] uppercase",
      descClassName: "",
      aosDelay: "800",
    },
  ]

  return (
    <div ref={sectionRef} className="px-5 xl:px-16 3xl:px-24 pt-16 bg-cover">
      <div className="xl:pt-80">
        <div className="" data-aos="fade-up" data-aos-duration="1000">
          <Title
            title="Why Choose Cyberstone SOCaaS?"
            type="h2"
            className="text-white text-[32px] xl:text-[54px] 2xl:text-[72px] 3xl:text-[120px] uppercase font-semibold"
          />
        </div>
        <div
          className="
            flex flex-col
            gap-6
            mt-16
            md:flex-row
            md:gap-9
            md:mt-32
           
          "
        >
          {cards.map((card, idx) => (
            <div
              key={idx}
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay={card.aosDelay}
              className="w-full "
            >
              <Card
                number=""
                title={card.title}
                description={card.description}
                className={`
                  
                  ${card.className}
                `}
                titleClassName={card.titleClassName}
                descClassName={card.descClassName}
                titleType="h4"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Whysection
